import { makeAnalyticsData } from '@atlassian/mpac-analytics';
import { FINISH_GENERATE_APP_SPECIFIC_PASSWORD, GENERATE_APP_SPECIFIC_PASSWORD_ERROR, REGENERATE_APP_SPECIFIC_PASSWORD_ERROR, START_REGENERATE_APP_SPECIFIC_PASSWORD } from '../../../actions/Installation/InstallMode/AppSpecificPassword';
import { ANALYTICS_CATEGORY_TOKENS, TokenGeneratedEvent, TokenGenerateFailedEvent, TokenRegeneratedEvent, TokenRegenerateFailedEvent } from '../../Events';
export default function AppSpecificPasswordMapper(action) {
  switch (action.type) {
    case FINISH_GENERATE_APP_SPECIFIC_PASSWORD:
    case START_REGENERATE_APP_SPECIFIC_PASSWORD:
      return makeAnalyticsData({
        eventType: action.type === FINISH_GENERATE_APP_SPECIFIC_PASSWORD ? TokenGeneratedEvent : TokenRegeneratedEvent,
        category: ANALYTICS_CATEGORY_TOKENS,
        actionSubjectId: 'token',
        containerType: 'context',
        containerId: action.context.id
      });
    case GENERATE_APP_SPECIFIC_PASSWORD_ERROR:
    case REGENERATE_APP_SPECIFIC_PASSWORD_ERROR:
      return makeAnalyticsData({
        eventType: action.type === GENERATE_APP_SPECIFIC_PASSWORD_ERROR ? TokenGenerateFailedEvent : TokenRegenerateFailedEvent,
        category: ANALYTICS_CATEGORY_TOKENS,
        actionSubjectId: 'token',
        containerType: 'context',
        containerId: action.context.id,
        attributes: {
          error: action.error
        }
      });
  }
}